import { Message, IMessage } from "./Message";

export interface IVideoMessage extends IMessage {
    Video:IVideo;
}

export interface IVideo {
    Blob:string;
    MimeType:string;
    Preview:string;
   
}

export const VideoMessage = (props:IVideoMessage) => {




    return <Message {...props}>
        <div className="row">
            <video controls autoPlay={props.IsInbound ? false:true}>

              <source src={props.Video.Blob} type={props.Video.MimeType} />
                    
            </video>
        </div>
    </Message>

}
